import { render, staticRenderFns } from "./widget-event.vue?vue&type=template&id=ee98ad7c&scoped=true"
import script from "./widget-event.vue?vue&type=script&lang=ts"
export * from "./widget-event.vue?vue&type=script&lang=ts"
import style0 from "./widget-event.vue?vue&type=style&index=0&id=ee98ad7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee98ad7c",
  null
  
)

export default component.exports